import styled from "@emotion/styled";
import { LG } from "constants/vp-sizes";
export const StyledCardButton = styled.div`
  margin-top: 24px;

  @media (max-width: ${LG}px) {
    margin-top: 16px;
  }
`;
